import { fetcher } from "@/shared/core-configs";
import { ErpProductInput } from "../types/ErpProduct";
import { API } from "@/config";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GET_ERP_PRODUCTS_FETCH_KEY } from "./useGetErpProducts";

export const syncStockErpProduct = async (
  id: string,
): Promise<ErpProductInput> => {
  const response = await fetcher.post(
    `${API.GESLUB}/erp-product/${id}/sync-stock`,
  );
  return response.data;
};

export const useSyncStockErpProduct = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: syncStockErpProduct,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_ERP_PRODUCTS_FETCH_KEY],
      });
    },
  });
  return {
    mutate: mutation.mutate,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isPending: mutation.isPending,
    error: mutation.error,
  };
};
